import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconStarActive({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" d="M15.032 9.43 12 4.5 8.968 9.43 3.053 10.66l4.031 4.206-.631 5.635L12 18.236l5.547 2.264-.631-5.635 4.031-4.206z" /><path fill="currentColor" fillRule="evenodd" d="M12 3.5c.374 0 .72.189.909.496l2.798 4.552 5.465 1.134c.367.076.664.332.778.673a.96.96 0 0 1-.224.977l-3.713 3.874.581 5.188a.98.98 0 0 1-.422.91c-.3.212-.697.255-1.04.115L12 19.324 6.868 21.42c-.343.14-.74.097-1.04-.114a.98.98 0 0 1-.422-.91l.581-5.19-3.713-3.873a.96.96 0 0 1-.224-.977c.114-.34.41-.597.778-.673l5.464-1.134 2.8-4.552c.188-.307.534-.496.908-.496m0 2.983L9.877 9.935a1.05 1.05 0 0 1-.684.473l-4.135.858 2.805 2.925c.202.212.3.495.268.78l-.441 3.936 3.895-1.59c.265-.108.565-.108.83 0l3.895 1.59-.44-3.936a.97.97 0 0 1 .268-.78l2.804-2.925-4.135-.858a1.05 1.05 0 0 1-.684-.473z" clipRule="evenodd" /></svg></>;
}
IconStarActive.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconStarActive;